import { Api } from '../../services/http/Api';
import { Triage, NewTriageData } from '../../types/orders/Triage';

export class TriageDataSource {
    async getByOrderId(orderId: number) {
        const result = (await new Api().fetch(`/triage/orderId/${orderId}`)) as Triage;
        return result;
    }

    async create(data: NewTriageData) {
        try {
            const result = await new Api().post('/triage/create', data);
            return result;
        } catch (e: any) {
            console.error(`Error: ${e.toString()}`);
            return null;
        }
    }

    types = {
        escreveu: 1,
        atualizacao: 2,
    };
}
